import { render, staticRenderFns } from "./countyBfjl.vue?vue&type=template&id=97d6440c&"
import script from "./countyBfjl.vue?vue&type=script&lang=js&"
export * from "./countyBfjl.vue?vue&type=script&lang=js&"
import style0 from "./countyBfjl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports